import { ApiResponses } from 'lib/trpcClient';
import { useMemo } from 'react';

type Props = {
  investorData?: ApiResponses['investor']['getInvestor'];
};

export const useSelectedInvestorWarnings = ({ investorData }: Props) => {
  const errors: { missingPrimaryTaxId?: string; missingTaxResidency?: string } =
    useMemo(() => {
      return {
        missingPrimaryTaxId:
          investorData && !investorData.primaryTaxId
            ? 'tax ID (e.g. NINO)'
            : undefined,
        missingTaxResidency:
          investorData && !investorData.taxResidencies?.length
            ? 'tax residency'
            : undefined,
      };
    }, [investorData]);

  return {
    hasErrors: Object.values(errors).some((error) => error),
    errors,
  };
};
